import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { SalidaForm } from "./components/SalidaForm";
import "./styles/CreacionSalida.css";

class CreacionSalida extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    navigateToBoleta = (salidaId) => {
        this.props.history.replace(
            `/produccion-bodega/salidas/${salidaId}/ver-boleta`,
        );
    };

    render() {
        const { user } = this.props;

        const nombreUsuario = user ? user.nombre : "No definido";

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Nueva Salida"
                    col="12"
                >
                    <SalidaForm
                        regresar={this.regresar}
                        navigateToBoleta={this.navigateToBoleta}
                        nombreUsuario={nombreUsuario}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(CreacionSalida);
